export enum MessageCategory {
  ALL,
  CANCEL_RESERVATION,
  CANCEL_CONFIRMATION,
  MODIFY_RESERVATION,
  STAY_PREFERENCES,
  ERROR_CHECK_AVAILABILITY,
  ASSOCIATE_RESERVATION,
  RESERVATION_AVAILABILITY
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/message/message-category.model.ts